import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTrackPage } from 'Tracking/tracking-api/useTrackPage';
type Props = {
  pageName: string;
  payload?: TrackPayload;
};
export const TrackRouterPage = ({ pageName, payload }: Props) => {
  const { trackPage } = useTrackPage();
  const router = useRouter();
  useEffect(() => {
    trackPage(pageName, payload);
  }, [router.asPath, pageName]);
  return null;
};
